import * as React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button, CircularProgress, Typography } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import UserQuery from "../../stateQueries/User";
import AlertPopup from "../AlertPopup";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2)
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1)
  }
}));

export default function DeleteBoardReflectionModal({ reflection }) {
  const [open, setOpen] = React.useState(false);
  const queryClient = useQueryClient();

  const deleteMutation = useMutation({
    mutationFn: async (id) => {
      return UserQuery.CSEQuery.deleteBoardReflection(id);
    },
    onSuccess: (data) => {
      setTimeout(() => {
        queryClient.invalidateQueries(["boardReflections"]);
        setOpen(false);
      }, 2000);
    }
  });

  const handleToggleOpen = () => {
    setOpen(!open);
  };

  const handleDelete = () => {
    deleteMutation.mutate(reflection.id);
  };

  return (
    <div>
      <IconButton onClick={handleToggleOpen} color="error" size="small">
        <DeleteIcon />
      </IconButton>

      {deleteMutation.isError && (
        <AlertPopup
          open={true}
          severity="error"
          message={
            deleteMutation.error?.response?.data?.message || "Server Error"
          }
        />
      )}
      {deleteMutation.isSuccess && (
        <AlertPopup open={true} message={deleteMutation.data?.message} />
      )}

      <BootstrapDialog
        onClose={handleToggleOpen}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Delete Board Reflection
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleToggleOpen}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography>
            Are you sure you want to delete the board reflection "
            <strong>{reflection?.title}</strong>"?
          </Typography>
          <Typography color="error" sx={{ mt: 2 }}>
            This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleToggleOpen}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleDelete}
            disabled={deleteMutation.isLoading}
            startIcon={
              deleteMutation.isLoading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <DeleteIcon />
              )
            }
          >
            {deleteMutation.isLoading ? "Deleting..." : "Delete"}
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
